export default __webpack_public_path__ + "static/media/KatieIvancic.e75b2ec8.jpg";